(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demax-home-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('demax-home-comparison')) {
 customElements.define('demax-home-comparison', class extends HTMLElement {
  connectedCallback() {
   this.demaxController?.abort();
   this.demaxController = new AbortController();
   const signal = this.demaxController.signal;
   const tabs = [...this.querySelectorAll('[role="tab"]')];
   const select = (tab, focus = false) => {
    tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
    this.querySelectorAll('[data-demax-panel]').forEach(panel => { panel.hidden = panel.dataset.demaxPanel !== tab.dataset.demaxModel; });
    if (focus) tab.focus();
   };
   tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab), {signal});
    tab.addEventListener('keydown', event => {
     let next;
     if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
     if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
     if (event.key === 'Home') next = 0;
     if (event.key === 'End') next = tabs.length - 1;
     if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
    }, {signal});
   });
   this.closest('.shopify-section').addEventListener('shopify:block:select', event => {
    const tab = tabs.find(item => item.dataset.demaxModel === event.detail.blockId);
    if (tab) select(tab);
   }, {signal});
  }
  disconnectedCallback() { this.demaxController?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();
})();
